import { Avatar } from 'ui/components/Avatar';
import { cn } from 'utils/cn';
import { ActiveUser } from '../../../store/siteInfoSlice';

export const Collaborator = (user: ActiveUser) => {
  const { email, avatar, first_name, last_name, norm_id } = user;

  const isOnline = true; // TODO: replace with actual online status
  return (
    <div className="flex items-center gap-[10px]">
      <div className="flex gap-2 relative">
        <div className={cn('relative border-2 rounded-xl p-0.5', isOnline ? 'border-ata-green' : 'border-gray-400')}>
          {isOnline && <div className='absolute bottom-[1px] right-[1px] h-3 w-3 border-2 border-white bg-ata-green dark:border-card rounded-full z-20'></div>}
          {!isOnline && <div className='absolute bottom-[1px] right-[1px] h-3 w-3 border-2 border-white bg-gray-400 dark:border-card rounded-full z-20'></div>}
          <Avatar
            borderRadius="lg"
            size="fit"
            src={avatar ?? undefined}
            email={email ?? undefined}
            id={parseInt(norm_id)}
            title={`${first_name}`}
            className="h-9 w-9"
          />
        </div>
        <div className="flex flex-col justify-center max-w-[170px] overflow-hidden">
          <span className="text-sm font-semibold text-textcolor truncate">{first_name} {last_name}</span>
          <span className="text-xs capitalize text-gray-400 truncate">
            Online
          </span>
        </div>
      </div>
    </div>
  );
};
